import 'css-chunksrc/client/scenes/constrainElement/endEndForm/styles.scss';export default {
  "form": "_form_18fy6_1"
};